import React, { useEffect } from "react";
import {
  CalenderIcon,
  LocationIcon,
  UserIcon,
  DefaultHotelIcon
} from "../../../../helper/HwIcon";
import imag1 from '../../../../assets/media/city.png'
import { useRecentSearch } from "../../hooks/useRecentSearch";
import Slider from "react-slick";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { useGetHotelStaticData } from "../../hooks/useGetHotelStaticData";
import { dividePeople } from "../../hooks/useSearchHotels";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const HotelRecentSearches = () => {
  const { details: staticData } = useGetHotelStaticData();
  const { data, loading, get } = useRecentSearch();
  const navigate = useNavigate();

  useEffect(() => {
    get();
  }, []);

  if (data?.length <= 0) {
    return null;
  }

  const navigateToList = (values) => {
    const roomInfo = dividePeople(
      values?.noOfRooms,
      values?.noOfAdult,
      values?.noOfChild,
      values?.childAges
    );
    const searchData = encodeURIComponent(
      btoa(
        unescape(
          encodeURIComponent(JSON.stringify(values?.city?.details))
        )
      )
    );
    
    if (!values?.city?.isCity) {
      const cityId = staticData?.cities?.find(
        (c) => c?.name === values?.city?.details?.cityName
      )?.code; 
      const city = values?.city?.details?.rateHawkCityCode || values?.city?.value || values?.city?.details?.code
      const url = `/hotels/list?checkinDate=${moment(
        values?.checkinDate
      ).format("YYYY-MM-DD")}&checkoutDate=${moment(values?.checkoutDate).format(
        "YYYY-MM-DD"
      )}&cid=${cityId || city || values?.cityValueExists}&hid=${
        !values?.city?.isCity ? values?.city?.value : ""
      }&ris=${roomInfo
        ?.map(
          (r) =>
            `${r?.noOfAdult}n${r?.noOfChild}${
              r?.childAges?.length > 0
                ? `n${r?.childAges?.map((d) => (!d ? 1 : d))?.join("a")}`
                : ""
            }`
        )
        .join("_")}&nationality=${values?.nationality?.value}${values?.city?.label ? `&keyword=${values?.city?.label}` : ''}&searchData=${searchData}`;
      navigate(url, {
        state: new Date().getTime(),
      });
      return;
    }

    const url = `/hotels/list?checkinDate=${moment(values?.checkinDate).format(
      "YYYY-MM-DD"
    )}&checkoutDate=${moment(values?.checkoutDate).format("YYYY-MM-DD")}&cid=${
      (values?.city?.value) ||
      values?.cityValueExists
    }&hid=${!values?.city?.isCity ? values?.city?.value : ""}&ris=${roomInfo
      ?.map(
        (r) =>
          `${r?.noOfAdult}n${r?.noOfChild}${
            r?.childAges?.length > 0
              ? `n${r?.childAges?.map((d) => (!d ? 1 : d))?.join("a")}`
              : ""
          }`
      )
      .join("_")}&nationality=${values?.nationality?.value}${values?.city?.label ? `&keyword=${values?.city?.label}` : ''}&residence=${values?.nationality?.code}&searchData=${searchData}`;
    navigate(url, {
      state: new Date().getTime(),
    });
  };


  return (
    <div className="hw-hotel--recentSection hw-pt--medium">
      <div className="hw-page--width">
        <div className="hw-mBox">
          <h2 className="h3 mb-20">Recent Searches</h2>
          {loading ? (
            <div className="row">
              <div className="col-6">
                <Skeleton width={"40vw"} height={"140px"} />
              </div>
              <div className="col-6">
                <Skeleton width={"40vw"} height={"140px"} />
              </div>
            </div>
          ) : (
            <Slider
              {...settings}
              nextArrow={<p>Next</p>}
              prevArrow={<p>Prev</p>}
            >
              {data?.map?.((d,index) => {
                let image = null;
                try {
                  const imageArr = d?.city?.details?.images && Array.isArray(d?.city?.details?.images) ? d?.city?.details?.images : JSON.parse([d?.city?.details?.images]);
                  image = imageArr?.[0];
                  if(image?.includes('size')){
                    image = image?.replace('{size}', '1024x768');
                  }
                } catch (error) {}
                return (
                  <div
                    className="hw-hotel--slideItem"
                    onClick={() => {
                      navigateToList(d);
                    }}
                  >
                    <div className="row hw-gapx10 align-items-center">
                      <div className="col-md-12 col-lg-3">
                        <div className="img-holder">
                          {
                            (d?.image || image) ? 
                            <img src={d?.image || image} alt="image" /> : <DefaultHotelIcon/>
                          }
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-9">
                        <div className="d-flex d-flex-column hw-gapx10">
                          <div>
                            <div className="hw-badge--text hw-badge--textSmall">
                              {d?.city?.details?.country || d?.city?.details?.countryName || d?.city?.country || d?.city?.label }
                            </div>
                          </div>
                          <div className="hw-hotel--filterResult__title">
                            {d?.city?.label ?? d?.keyword}
                          </div>
                          <div className="hw-hotel--filterResult__review">
                            {/* (5.0) */}
                          </div>
                          <div className="d-flex hw-gapy4 align-items-center hw-icon--blue hw-fontWeight--500">
                            <LocationIcon />
                            {d?.hotel?.label ?? d?.city?.label ?? d?.keyword}
                          </div>
                          <div className="d-flex hw-gapy4 align-items-center hw-icon--blue hw-fontWeight--500">
                            <UserIcon />
                            {d?.noOfRooms} Room(s) {d?.noOfAdult} Adult(s){" "}
                            {d?.noOfChild} Child(s)
                          </div>
                          <div className="d-flex hw-gapy4 align-items-center hw-icon--blue hw-fontWeight--500">
                            <CalenderIcon />
                            Check In{" "}
                            {moment(d?.checkinDate).format("DD/MM/YYYY")} |
                            Check Out{" "}
                            {moment(d?.checkoutDate).format("DD/MM/YYYY")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          )}
        </div>
      </div>
    </div>
  );
};
